import { Component, OnInit } from '@angular/core';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { StudentService } from 'src/app/services/Student/student.service';
import { LookupService } from 'src/app/services/Common/lookup.service';
import { GlobalHelper } from 'src/app/services/Common/global.service';

@Component({
  selector: 'app-studentfeebookupload',
  templateUrl: './studentfeebookupload.component.html',
  styleUrls: ['./studentfeebookupload.component.css']
})
export class StudentfeebookuploadComponent implements OnInit {

  StudentModel = {
    ClassID:0,
    SectionID:0
  }
  ClassList:any;
  SectionList:any;
  SelectUpload:any;
  loadingUpload:any;
  Submitted:any;
  StudentList:any;
  constructor(private studentService:StudentService,private spinnerService: Ng4LoadingSpinnerService,private lookupService:LookupService,public globalHelper :GlobalHelper) { }

  
  GetClass  () {
    this.lookupService.GetLookupsList('Class', '').subscribe( (data)=> {
        this.ClassList = data.LookupItems;
    });
}

GetSection  () {
    this.StudentModel.SectionID = 0;
    var ItemBo = {
        ItemId:this.StudentModel.ClassID
    }
    this.lookupService.GetLookupsList('SectionName', JSON.stringify(ItemBo)).subscribe( (data)=> {
        this.SectionList = data.LookupItems;              
    });
}

selectUpload  (event) {
  this.SelectUpload = event.target.files[0];
}


 ValidityState() {

    return this.StudentModel.ClassID == 0;
}

UploadStudent  () {
 
    this.Submitted = true;
    if (!this.ValidityState()) {
        this.loadingUpload = true;
        this.spinnerService.show();
        this.studentService.UploadFeeBookStudent(this.SelectUpload,JSON.stringify(this.StudentModel)).subscribe( (response)=> {
            this.Submitted = false;
            this.spinnerService.hide();
            this.StudentList = response.StudentList;
            // for ( var i = 0; i < this.StudentList.length; i++) {
            //     for (var j = 1; j < this.SectionList.length; j++) {
            //         if (this.SectionList[j].ItemName == this.StudentList[i].SectionName) {
            //             this.StudentList[i].SectionID = this.SectionList[j].ItemId;
            //         }
            //     }
                
            // }
    
     


    });
}

}

 
UpdateStudent  () {
  
  var numbers = new RegExp(/^[0-9]+$/);

    for (var i = 0; i < this.StudentList.length; i++) {
        var StudentNo = this.StudentList[i].StudentNo;
        
        if (StudentNo != '') {

            if (StudentNo == 0) {
                alert('GR Should not be Zero');
                return;
            }

            else if (numbers.test(StudentNo) == false) {
                alert('GR Should be No. Only');
                return;
            }
           
        }
       
    }

    this.spinnerService.show();
    this.studentService.UpdateFeeBookStudent(JSON.stringify(this.StudentList)).subscribe( (response)=> {
       this.globalHelper. CheckActionStatus(response);
       this.spinnerService.hide();
    });

}


ngOnInit() {
    this.GetClass();           
}
  

}
